import { TableWrapper } from '@bitstopco/bitstop-theme';
import { skipToken } from '@reduxjs/toolkit/query';
import { useState } from 'react';
import { useNavigate } from 'react-router';

import CardTable from '@/components/ui/card/CardTable';
import { useGetRestockRequestsQuery } from '@/store/api/services/restocking/restocking';

import { DEFAULT_PAGINATION } from '@/constants/api';
import {
  RESTOCKING_LOAD_ORDERS_COLUMNS,
  RESTOCKING_LOAD_ORDERS_FILTERS_CONFIG,
} from '@/constants/app/restocking';

import type { RestockRequestView } from '@/types/generated/athena';
import type { ApiListingRequest } from '@bitstopco/bitstop-theme';

const LoadOrders = () => {
  const navigate = useNavigate();
  const [payload, setPayload] = useState<ApiListingRequest>();

  const {
    data: {
      data: ordersData = [],
      meta: { pagination: metaPagination = DEFAULT_PAGINATION } = {},
    } = {},
    isFetching,
  } = useGetRestockRequestsQuery(payload || skipToken);

  const handleRow = (restockRequestView: RestockRequestView) =>
    navigate(`/restocking/load-orders/${restockRequestView.id}`);

  return (
    <CardTable>
      <TableWrapper<RestockRequestView>
        data={ordersData}
        hideActionMenu
        isLoading={isFetching || !payload}
        sortByDefaultValue="created_at"
        columns={RESTOCKING_LOAD_ORDERS_COLUMNS}
        dateRangeFilterKey="created_at"
        filterConfigs={RESTOCKING_LOAD_ORDERS_FILTERS_CONFIG}
        totalPages={metaPagination?.total_pages}
        totalItems={metaPagination?.total_items}
        tableProps={{
          placeholder: {
            empty: {
              title: 'No machines found',
              content:
                "We can't find any machine that matches your search, please try a different request",
            },
          },
        }}
        tableToolbarProps={{
          searchPlaceholder: "Search by machine's name, code, and ID",
        }}
        onChange={setPayload}
        onRowClick={handleRow}
      />
    </CardTable>
  );
};

export default LoadOrders;
